import { FC, memo } from "react";
// import { useSelector } from "react-redux";
import GuestLayout from "./guest-layout";
import AuthorizedLayout from "./authorized-layout";
import Theme from "common/components/base/theme/Theme";
import SignedOutView from "common/components/custom/signed-out-view/SignedOutView";
import { useAppSelector } from "common/redux/core";
import { UserLoginStatus } from "common/enums/api-status.enum";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "common/config/auth.config";
// import { RootState } from "common/redux/core/root.reducer";

const Layout: FC = () => {
  // const { theme } = useSelector((state: RootState) => state.app);
  const { loginStatus } = useAppSelector((state) => state.user);
  if (
    loginStatus === UserLoginStatus.LOGIN_PROGRESS ||
    loginStatus === UserLoginStatus.LOGGED_IN
  ) {
    return (
      <>
        <Theme variant="custom" />
        <MsalProvider instance={msalInstance}>
          <AuthorizedLayout />
        </MsalProvider>
      </>
    );
  } else {
    return (
      <>
        <Theme variant="custom" />
        <GuestLayout>
          <SignedOutView />
        </GuestLayout>
      </>
    );
  }
};

export default memo(Layout);
